import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { UserList } from './UserList';
import { useState } from 'react';
import PopUp from './PopUp';
import Header from "./Header";
import Loader from "./Loader";
import "./css/AdminBookings.css";
import { API_BASE_URL, UsersGetAPIEndPoint } from '../constant';
import { useEffect } from 'react';



//export const userList = UserList;




export default function OwnerList() {
const token = sessionStorage.getItem("JWTtoken");

 const [users, setUsers] = useState([]);
const [userStatus, setUserStatus] = useState("All");
const [loading, setLoading] = useState(false);
const [userData, setUserData] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const [error, setError] = useState("");


  const recordsPerPage = 4; 


const indexOfLast = currentPage * recordsPerPage;
const indexOfFirst = indexOfLast - recordsPerPage;

const currentRecords = userData.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(userData.length / recordsPerPage);

const setResidentID = sessionStorage.getItem("residentId");
const userType = sessionStorage.getItem("userType");



  const [showPopUp, setShowPopUp] = useState(false);
 
 useEffect(() => {
    fetchUsers();
  }, []);

 const fetchUsers = async () => {
      try {
        const apiURL = API_BASE_URL + UsersGetAPIEndPoint;
        const response = await fetch(apiURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        });
        const res = await response.json();

        if (res.status) {          
          setUserData(res.data);
          //alert(userData.length);
        } else {
          setError(res.message || "Failed to fetch notices");
        }
      } catch (err) {
        setError("Server error");
      } finally {
        setLoading(false);
      }
    };


  const GetAll = async(status) =>{
    
    setLoading(true);    
    setCurrentPage(1);  

    try {
        const apiURL = API_BASE_URL + UsersGetAPIEndPoint;
        const response = await fetch(apiURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        });
        const res = await response.json();

        if (res.status) {
          if(status !== "")
          {
            setUserStatus(status);
            const loggedInUserData = res.data.filter(user => user.status === status);
            //console.log("LoggedInUserData => manjit");
            setUserData(loggedInUserData);
          }
          else
          {
            //alert(status);
            setUserStatus("All");
            const loggedInUserData = res.data;            
            setUserData(loggedInUserData);            
            //setUserData(userData);
          }
          setUsers(res.data);
        } else {
          setError(res.message || "Failed to fetch users");
        }
      } catch (err) {
        setError("Server error");
      } finally {
        setLoading(false);
      }
  }
  
    return (<>
    <Header/>  
    {

      
        /*
<TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Dessert (100g serving)</TableCell>
            <TableCell align="right">FlatNumber</TableCell>
            <TableCell align="right">Name</TableCell>
            <TableCell align="right">Sold</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {userList.map((row) => (
            <TableRow
              key={row.FlatNumber}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell > {row.FlatNumber}</TableCell>
              <TableCell align="right">{row.Name}</TableCell>
              <TableCell align="right">{row.Sold}</TableCell>
              <TableCell align="right">{row.OccupiedBy}</TableCell>
              <TableCell align="right"> <button onClick={()=>setShowPopUp(true, row.FlatNumber)}>View</button> </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer> 
        */





    <div className="admin-bookings">        
      <h2 style={{ textTransform: 'capitalize' }}>{userStatus} Users                
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("0")}
                >
                  Inactive
                </button> 
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("1")}
                >
                  Active
                </button> 
                <button
                  className="btn-approve"
                  style={{ float : "right" }}
                  onClick={() => GetAll("")}
                >
                  All
                </button> 
                
                
                
      </h2>
        {loading && <Loader />}

 <div className="table-container">
      <table>
        <thead>
          <tr>
            <th>FlatNumber</th>
            <th>Name</th>
            <th>Sold</th>
            <th>OccupiedBy</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>          
          {
          currentRecords.length > 0 ? (
              currentRecords.map((row) => (
            <tr key={row.id} style={{ borderBottom: "1px solid #dee2e6"}}>
              <td>{row.apartment}</td>
              <td>{row.name}</td>
              <td>{row.sold}</td>
              <td>({row.owner})</td>
              <td>{row.status}</td>
              
              <td>
                {( row.status !== "1" ) &&  <button                
                  className="btn-reject"
                  //onClick={() => updateStatus(data, "rejected")}
                style={{ marginLeft: "6px" }}
                >
                  Activate 
                </button>}
                 {( row.status === "1" ) &&  <button                
                  className="btn-approve"
                  //onClick={() => updateStatus(data, "rejected")}
                style={{ marginLeft: "6px" }}
                >
                  Inactivate
                </button>}
              </td>
            </tr>
          ))
          ) : (
            <tr>
              <td colSpan="6" align="center">No records found</td>
            </tr>
          )
          }
        </tbody>
      </table>
</div>

<div style={{ marginTop: "10px" }}>
    <button
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}> Prev 
  </button>

  {[...Array(totalPages)].map((_, i) => (
    <button
      key={i}
      onClick={() => setCurrentPage(i + 1)}
      style={{
        fontWeight: currentPage === i + 1 ? "bold" : "normal",
        margin: "0 5px"
      }}
    >
      {i + 1}
    </button>
  ))}

  <button
    onClick={() =>
      setCurrentPage(prev => Math.min(prev + 1, totalPages))
    }
    disabled={currentPage === totalPages}
  >
    Next
  </button> { indexOfFirst + 1} to {userData.length < indexOfLast ? userData.length : indexOfLast} of Total Record {userData.length} 
</div>
    </div>


    }
    
    
    <PopUp showPopUp={showPopUp} closePopUp={()=>setShowPopUp(false)}>
          <h2> pop up opened</h2>  
    </PopUp>
    
    </>

    
  );
  };